module.exports = __webpack_public_path__ + "static/media/Avenir-Book.c234b1f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Avenir-Book.ttf
// module id = 1000
// module chunks = 0 1 2 4 5 6 9 18 19 20 21